import { useDataValue } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useClient, useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import query from './query.graphql.js'
import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let procedure_ids = useDataValue({
    context: 'selected',
    path: 'procedure_ids',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let client = useClient()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    let response = await client
      .query(query, { location_ids: args.location_ids, procedure_ids })
      .toPromise()
    let objects = response.data.vaxiom_sys_organizations.flatMap(organization =>
      response.data.vaxiom_procedures.map(procedure => ({
        name: procedure.name,
        description: procedure.description,
        requires_diagnosis: procedure.requires_diagnosis,
        requires_images: procedure.requires_images,
        organization_id: organization.id,
      }))
    )
    let mutationResponse = await executeMutation({
      objects,
    })
    if (mutationResponse.error) {
      notify(notifyError('An error has occurred while copying procedures.'))
      return
    }

    notify(notifySuccess('Procedure has been copied to target locations.'))

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
